
import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { jaJP } from '@mui/x-data-grid'
import { addDays, format } from 'date-fns'
import { usePost } from './../../apis/ApiRequests'
import { useAuth } from '../../contexts/AuthContext'
import { dateToString } from '../../utils/Library'
import Header from '../../components/Header'
import Frame from '../../components/uiParts/Frame'
import TitleBar from '../../components/uiParts/TitleBar'
import { CustomDataGrid } from '../../components/dataGrid/CustomDataGrid'
import BidSearchForm from '../../components/uiParts/bid/BidSearchForm'
import CustomCheckbox from '../../components/input/CustomCheckbox'


const DataInput = () => {

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const { authInfo }   = useAuth()
    const facilityCode   = authInfo.facilityCode
    const facilityName   = authInfo.facilityName
    const userId         = authInfo.userId
    const luserName      = authInfo.userName
    const authority      = authInfo.authority
    const today          = format(addDays(new Date(), 0), 'yyyy-MM-dd')
    const navigate       = useNavigate()
    
    const search    = useLocation().search
    const query     = new URLSearchParams(search)
    const targetDate  = query.get("targetDate") || today
    const checkStatus  = query.get("checkStatus") || 1

	//-----------------------------------------------
    // initialize - useState
	//-----------------------------------------------
    const [ entryDate,             setEntryDate             ] = useState(targetDate)
    const [ condition ,            setCondition             ] = useState('')
    const [ searchStatus ,         setSearchStatus          ] = useState(checkStatus)
    const [ searchCount,           setSearchCount           ] = useState(0)
    const [ dataGridHeight,        setDataGridHeight        ] = useState(window.innerHeight - 210)
    const [ checkedBidList,        setCheckedBidList        ] = useState([])
    const [ dataInputList,         setDataInputList         ] = useState([])
    const [ checkedDataInputList,  setCheckedDataInputList  ] = useState([])
    
	//===============================================
	// API
	//===============================================
	//-----------------------------------------------
    // API - searchDataByDataInput / BidGroup
	//-----------------------------------------------
    const { response : searchData_res, loading : searchData_Loading, post:searchData_post } = usePost()
    const searchData = async () => {
        const numericDate = dateToString(entryDate)
        const postData = {
            'className'    : 'mch.models.table.Transaction',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'keyword1'     : numericDate,
            'keyword2'     : condition,
            'keyword3'     : searchStatus
        }
        await searchData_post(postData)
    }
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - ロード時の設定
	//-----------------------------------------------
    useEffect(() => {

        setSearchCount(searchCount+1)
        
        const handleResize = () => {
            setDataGridHeight(window.innerHeight - 210)
        }
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
        
    },[])
	//-----------------------------------------------
    // useEffect - 検索処理
	//-----------------------------------------------
    useEffect(() => {
        searchData()
    }, [searchCount])
	//-----------------------------------------------
    // useEffect - APIレスポンス(searchDataByDataInput / bidGroup)
	//-----------------------------------------------
    useEffect(() => {
        setDataInputList([])
        if (searchData_res) {
            setDataInputList(searchData_res.Data)
        }
    }, [searchData_res])

	//===============================================
	// eventHandler
	//===============================================
	//-----------------------------------------------
    // eventHandler - 検索ボタン
	//-----------------------------------------------
    const handleClick_search = () => {
        setSearchCount(searchCount+1)
    }
	//-----------------------------------------------
    // eventHandler - 検索クリアボタン
	//-----------------------------------------------
    const handleClick_search_clear = () => {
        setEntryDate(today)
        setCondition('')
        setSearchStatus(1)
        setSearchCount(searchCount+1)
    }
	//===============================================
	// dataGrid
	//===============================================
	//-----------------------------------------------
    // dataGrid - テーブルの見出し
	//-----------------------------------------------
    const columnsxBidGroup = [
        { field: 'entryDate', headerName: '入札登録日',   width: 110, columnSeparatorWidth: 1, sortable:false,
            renderCell: (params) => (
            <div
                style={{
                    color: params.row.checkStatus === 0
                    ? 'red'
                    : params.row.checkStatus === 1
                    ? 'blue'
                    : 'inherit',
                }}
            >
                {params.value}
            </div>
            ),
        },
        { field: 'reportNo',      headerName: '浜帳No', width: 100, columnSeparatorWidth: 1, align:'right', 
            renderCell: (params) => (
            <div
                style={{
                    color: params.row.checkStatus === 0
                    ? 'red'
                    : params.row.checkStatus === 1
                    ? 'blue'
                    : 'inherit',
                }}
            >
                {params.value}
            </div>
            ),
        },
        { field: 'senmei',   headerName: '荷主',   width: 180, columnSeparatorWidth: 1, sortable:false, 
            renderCell: (params) => (
            <div
                style={{
                    color: params.row.checkStatus === 0
                    ? 'red'
                    : params.row.checkStatus === 1
                    ? 'blue'
                    : 'inherit',
                }}
            >
                {params.value}
            </div>
            ),
        },
        { field: 'displayGyoshu', headerName: '品名',   width: 350, columnSeparatorWidth: 1, sortable:false,
            renderCell: (params) => (
            <div
                style={{
                    color: params.row.checkStatus === 0
                    ? 'red'
                    : params.row.checkStatus === 1
                    ? 'blue'
                    : 'inherit',
                }}
            >
                {params.value}
            </div>
            ),
        },
        {
            field: 'checkStatus',
            headerName: 'ステータス',
            width: 125, sortable:false,
            renderCell: (params) => (
              <div
                style={{
                    color: params.row.checkStatus === 0
                    ? 'red'
                    : params.row.checkStatus === 1
                    ? 'blue'
                    : 'inherit',
                }}
            >
                {statusMapping[params.value] || params.value}
              </div>
            ),
        },
        { field: 'correctDate', headerName: '補正登録日',   width: 110, columnSeparatorWidth: 1, sortable:false,
            renderCell: (params) => (
            <div
                style={{
                    color: params.row.checkStatus === 0
                    ? 'red'
                    : params.row.checkStatus === 1
                    ? 'blue'
                    : 'inherit',
                }}
            >
                {params.value}
            </div>
            ),
        },
        { field: 'transferDate', headerName: '連携日',   width: 110, columnSeparatorWidth: 1, sortable:false,
            renderCell: (params) => (
            <div
                style={{
                    color: params.row.checkStatus === 0
                    ? 'red'
                    : params.row.checkStatus === 1
                    ? 'blue'
                    : 'inherit',
                }}
            >
                {params.value}
            </div>
            ),
        },
    ]
    const statusMapping = {
        0: '未チェック',
        1: 'チェック完了',
        9: '連携済み',
    }
    //-----------------------------------------------
    // dataGrid - 行の選択
    //-----------------------------------------------
    const handleClick_dataInputList = (event) => {
        const uniqueKey = event.row.reportNo
        navigate('/dataInputList?reportNo=' + uniqueKey + '&targetDate=' + entryDate + '&checkStatus=' + searchStatus)
    }
	//===============================================
	// Function
	//===============================================
    //===============================================
    // Css
    //===============================================
    
	//===============================================
	// JSXのレンダー
	//===============================================
	//-----------------------------------------------
	// eventHandler - 検索Statusの変更
	//-----------------------------------------------
    const handleChange_searchStatus = (checked) => {
        checked ? setSearchStatus(1) : setSearchStatus('')
        setSearchCount(searchCount+1)
    }
    return (
        <>
            <Header loginInfo="on" backButton="on" backPage="/home" />
            <div className='dataInput bodyContens'>
                <TitleBar title="データ補正" />
                <div className='mainContents'>
                    <Frame classname="frame" title="浜帳検索">
                        <div style={{display:'flex'}}>
                            <div> 
                                <BidSearchForm
                                    targetDateId       = "dataInput_targetDate"
                                    targetDateValue    = { entryDate }
                                    targetDateOnChange = { (e) => setEntryDate(e.target.value) }
                                    keywordId          = "dataInput_condition"
                                    keywordValue       = { condition }
                                    keywordOnChange    = { (e) => setCondition(e.target.value) }
                                    handleSearch       = { () => handleClick_search() }
                                    handleSearchClear  = { () => handleClick_search_clear() }
                                />
                            </div>
                            <div style={{marginLeft:'20px'}}>
                                <CustomCheckbox
                                    defaultChecked = { searchStatus == 0 ? false : true }
                                    onChange       = { (e) => handleChange_searchStatus(e.target.checked) }
                                    label          = "未チェックを表示"
                                />
                            </div>
                        </div>
                        <div style={{marginTop:'10px'}}>
                            <CustomDataGrid
                                getRowClassName={(params) =>
                                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                                }
                                editMode                = "row"
                                disableSelectionOnClick = { true } 
                                rows                    = { dataInputList }
                                columns                 = { columnsxBidGroup }
                                sx                      = { {height:dataGridHeight,fontSize:14,borderColor: 'primary.light',} }
                                density                 = "compact"
                                localeText              = { jaJP.components.MuiDataGrid.defaultProps.localeText }
                                showColumnRightBorder
                                showCellRightBorder
                                disableRowSelectionOnClick = {true}
                                disableColumnMenu          = {true}
                                onCellClick                = {(event) => handleClick_dataInputList(event)}
                                loading = { searchData_Loading }

                            />
                        </div>
                    </Frame>
                </div>
            </div>
        </>
    )
}
export default DataInput
